import type { Product } from '@mc/api'
import { trackGoldStandardPurchaseClick } from '@mc/pre-paywall-events'
import { segment, track } from '@mc/track-event'

export const trackJoinEmailClick = (slug: string) =>
  track(segment.EventTypes.COURSE_MARKETING_CLICK, {
    category: 'hero',
    location: 'hero',
    action: 'Join Waitlist',
    page_type: 'class-page',
    class_type: 'camp',
    class: slug,
    instructor_coming_soon: true,
  })

// The post-waitlist sign-up CTA routes into the quiz funnel (ctaHref), so it is
// middle-funnel: fire the gold-standard "Purchase Click". The waitlist email submit (trackJoinEmailClick) stays separate.
export const trackComingSoonPurchaseClick = (
  slug: string,
  href: string,
  annualPass?: Product | null,
) =>
  trackGoldStandardPurchaseClick({
    action: 'waitlist',
    location: 'hero',
    href,
    class: slug,
    purchaseClickProps: {
      category: 'hero',
      page_type: 'class-page',
      class_type: 'camp',
      instructor_coming_soon: true,
    },
    annualPass,
  })
